import { render, staticRenderFns } from "./OtherServices.vue?vue&type=template&id=5080dc20&"
import script from "./OtherServices.vue?vue&type=script&lang=js&"
export * from "./OtherServices.vue?vue&type=script&lang=js&"
import style0 from "./OtherServices.vue?vue&type=style&index=0&id=5080dc20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports